// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  width: 100%;\n  height: 100%;\n}\nbody {\n  width: 100%;\n  height: 100%;\n}\n#app {\n  width: 100%;\n  height: 100%;\n}\n.full-size {\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
